module.exports = __webpack_public_path__ + "static/media/LS014B7DD01_Spec_LCP-0620031B.0472b1b2.pdf";